import React, { useContext } from "react";
import "../designcss/Boosttitle.css";
import Whatsappmarketing from "../../../../images/LandingPageImage/dashboard.webp";
import Patternfirstherosection from "../../../../images/LandingPageImage/Pattern.png";
import { FcGoogle } from "react-icons/fc";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const BoostTitle = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
      <div className="boost-container">
        <img src={Patternfirstherosection} alt="" className="pattern" />

        <div className="boost-title">
          <h3>
            Supercharge Your Business
            <span className="highlight">With WoSender</span>
          </h3>
          <div className="boostpreview">
            <p>Send Faster. Automate Better. Engage Smarter. Convert More.</p>
          </div>
        </div>

        <div className="boost-btn">
          <Link to="/login">
          
          <button className="boostBtn1">
            <FcGoogle /> Start With Google
          </button>
          </Link>
          
          <button
          onClick={openFreeTrialModal} className="boostBtn2">Start Free Trial</button>
        </div>

        <div className="imgcontainer">
          <img src={Whatsappmarketing} alt="" />
        </div>
      </div>
    </>
  );
};

export default BoostTitle;
